import { Item, Item_Exception, Price, Stock_Record } from "../../models/RestModels";
import { ItemInfo, ItemOptionInfo } from "../../models/models";
import { getEmptyItem } from './Item';

export function getEmptyItemInfo(): ItemInfo
{
		let item:Item = getEmptyItem();

		let empty:ItemInfo = {
			item,
			records:[] as Stock_Record[],
			prices:[] as Price[],
			category: null,
			options: [] as ItemOptionInfo[],
			exceptions: [] as Item_Exception[],
			serials:[]
		};

		return empty;
}
